import { Component, OnInit, TemplateRef } from '@angular/core';

import { ArkUnitOfWork } from 'app/core/core.module';
import { Involvement, InvolvementSkill } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-view',
    template: `
        <div class="page-content page-fill">
            <dx-form [formData]="filter" [colCount]="4" class="mb-3">
                <dxi-item
                    dataField="skillId"
                    [label]="{ text: 'Skill' }"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: skills, valueExpr: 'id', displayExpr: 'name' }"
                ></dxi-item>
                <dxi-item dataField="whenFrom" [label]="{ text: 'When' }" [editorType]="'dxDateBox'" [editorOptions]="{ type: 'date' }"></dxi-item>
                <dxi-item dataField="whenTo" [label]="{ text: 'to' }" [editorType]="'dxDateBox'" [editorOptions]="{ type: 'date' }"></dxi-item>
                <dxi-item>
                    <div *dxTemplate>
                        <dx-button text="Go" type="default" (onClick)="search()"></dx-button>
                    </div>
                </dxi-item>
            </dx-form>
            <div class="flex-fill grid-fill">
                <dx-data-grid
                    #grid
                    [dataSource]="involvements"
                    keyExpr="id"
                    [showBorders]="true"
                >
                    <dxi-column dataField="person_LastName" caption="Last Name"></dxi-column>
                    <dxi-column dataField="person_FirstName" caption="First Name"></dxi-column>
                    <dxi-column dataField="when" dataType="datetime"></dxi-column>
                    <dxi-column dataField="skill_Name" caption="Skill"></dxi-column>

                    <dxo-selection mode="none"></dxo-selection>
                    <dxo-search-panel [visible]="true"></dxo-search-panel>
                </dx-data-grid>
            </div>
        </div>
    `,
    styles: [],
    imports: [DevExtremeModule]
})
export class ViewComponent implements OnInit {
    skills: InvolvementSkill[];
    involvements: Involvement[];
    selectedSkill: InvolvementSkill;
    filter = { skillId: null, whenFrom: null, whenTo: null };

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService) {}

    async ngOnInit() {
        this.skills = await this.uow.involvementSkills.all('name');
    }

    async search() {
        let query = this.uow.involvements.baseQuery();

        if (this.filter.skillId) query = query.where('skillId', '==', this.filter.skillId);
        if (this.filter.whenFrom) query = query.where('when', '>=', this.filter.whenFrom);
        if (this.filter.whenTo) query = query.where('when', '<=', this.filter.whenTo);

        query = query
            .orderBy(['when desc', 'person.lastName', 'person.firstName'])
            .select(['id', 'when', 'person.firstName', 'person.lastName', 'skill.name'])

        this.involvements = (await this.uow.executeQuery(query)) as Involvement[];
    }
}
